import axios from '@utils/axios';
import { setPopup, updateInfo } from '../actions';
import { select } from 'redux-saga/effects';
import { CopySurveySection } from '../types';
import { surveyQuestionsApiUrl, surveySectionOptionAssetsApiUrl } from './consts';
import { putEffect } from '../../../../../shared/utils/putEffect';
import { getApiError } from '../../../../../shared/utils/getApiError';
import { getApiEndPointUrl } from '../../../../../shared/utils/getApiEndpointUrl';
import { getQuestionsResponse } from './createSection';

export function* handleCopySurveySection(action: CopySurveySection) {
	const { sectionId, moderated } = action.payload;
	const { currQuesId, surveyId, surveys } = yield select((s) => s.surveyBuilder);
	const questionnaireId = surveys[surveyId]?.questionnaireId;
	try {
		const { data } = yield axios.post(
			getApiEndPointUrl(surveyQuestionsApiUrl, 'clone-section', `${sectionId}?questionnaireId=${questionnaireId}`)
		);
		const responseOfData = getQuestionsResponse(data?.surveys?.[0]?.questions);
		yield putEffect(updateInfo(currQuesId, responseOfData, action?.payload?.moderated));
		// if (data[0]) yield putEffect(selectQues(data[0].id, true, action?.payload?.moderated));
	} catch (e) {
		yield putEffect(setPopup(getApiError(e)));
	}
}
